export default __webpack_public_path__ + "economiesbc4b82.png";